import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ disabled, help, placeholder, type = 'text', ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-input')
    child.attrs.type = type
    child.attrs.disabled = disabled
    child.attrs.placeholder = placeholder
    this.children = [child]
    if (help) {
      this.children.push({
        component: 'small',
        innerText: help,
        attrs: { class: 'field-info' }
      })
    }
  }
}
